import React from "react"
import {
  ButtonGroup as ReactstrapButtonGroup,
  ButtonGroupProps,
} from "reactstrap"

interface Props extends ButtonGroupProps {
  size: "sm" | "lg"
}

export const ButtonGroup: React.FC<Props> = ({ size, ...rest }) => {
  return <ReactstrapButtonGroup size={size} {...rest} />
}
